export let props = {}
export let model = {}
export let computed = {}
